<template>
  <v-data-table
    class="elevation-2"
    :headers="headers"
    :items="commoditiesToDispatch"
    :items-per-page="-1"
    hide-default-footer>
    <template #[`item.processId`]="{ item }">
      {{ processUtil.getProcessesNumber(processList, getRawItem(item).processId) }}
    </template>
    <template #[`item.grainType.name`]="{ item }">
      {{ getRawItem(item).grainType?.name || '' }}
    </template>
    <template #[`item.qualityType.qualityType`]="{ item }">
      {{ getRawItem(item).qualityType?.qualityType || '' }}
    </template>
    <template #[`item.bagQuantity`]="{ item }">
      <div class="stock-hint">stock = {{ getRawItem(item).bagQtyStock }}</div>
      <v-text-field
        v-model="getRawItem(item).bagQuantity"
        type="number"
        step="1"
        label="Retira"
        min="0"
        variant="outlined"
        density="compact"
        :readonly="readonly"
        :rules="[rules.requiredFieldRule, rules.noLessThanZero]"
        required
      />
    </template>
    <template #[`item.amount`]="{ item }">
      <div class="stock-hint">stock = {{ getRawItem(item).stock }} kg</div>
      <v-text-field
        v-model="getRawItem(item).amount"
        type="number"
        step="1"
        label="Retira"
        min="0"
        variant="outlined"
        density="compact"
        :readonly="readonly"
        :rules="[rules.requiredFieldRule, rules.min0]"
        required
      />
    </template>
    <template #no-data>
      <v-alert type="warning" variant="tonal">
        Recuerde seleccionar mercaderia de salida
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessUtil from '../../services/process/ProcessUtilFunctions'

export default {
  name: 'CommodityDetailToDispatch',
  props: {
    readonly: Boolean
  },

  data: () => ({
    processUtil: null,
    processList: [],
    valid: true,
    rules: {
      requiredFieldRule: v => !!v || 'Campo requerido.',
      min0: v => (v > 0) || 'Debe ingresar un valor mayor que 0',
      noLessThanZero: v => (v >= 0) || 'Debe ingresar un valor mayor o igual que 0'
    },
    commoditiesToDispatch: [],
    headers: [
      {title: 'P. de P.', align: 'center', key: 'processId', sortable: false},
      {title: 'Grano', align: 'center', key: 'grainType.name', sortable: false},
      {title: 'Calidad', align: 'center', key: 'qualityType.qualityType', sortable: false},
      {title: 'Gramaje', align: 'center', key: 'gramaje', sortable: false},
      {title: 'Bultos a Retirar', align: 'center', key: 'bagQuantity', sortable: false},
      {title: 'Kg a Retirar', align: 'center', key: 'amount', sortable: false}
    ]
  }),

  created () {
    this.processUtil = ProcessUtil
    this.processList = this.$store.getters['processModule/getProcesses']
  },

  computed: {
    ...mapGetters('outcomeModule', ['isDialogActived']),
    ...mapGetters('commodityModule', ['getSelectedItems'])
  },

  watch: {
    getSelectedItems: {
      immediate: true,
      handler (value) {
        this.commoditiesToDispatch = value || []
        this.commoditiesToDispatch.forEach(x => {
          if (x.stock === undefined || x.stock === null) x.stock = x.amount
          if (x.bagQtyStock === undefined || x.bagQtyStock === null) x.bagQtyStock = x.bagQuantity
        })
      }
    }
  },

  methods: {
    getRawItem (item) {
      return item.raw || item
    }
  }
}
</script>

<style scoped>
.stock-hint {
  color: rgb(var(--v-theme-primary));
  font-size: 0.8rem;
  margin-bottom: 4px;
}
</style>
